import avatarUserDefault from '@/assets/images/avatar-user-default.png'

const balanceClientsTable = {
  columns: {
    getColumnsData: 'balanceClientsColumnsData',
    setColumnsData: 'setBalanceClientsColumnsData'
  },
  rows: {
    getRowsData: 'balanceClientsRowsData',
    setRowsData: 'setBalanceClientsRowsData'
  }
}

const balanceClientsTableColumns = [
  {
    id: 0,
    property: 'vip',
    nameRoute: 'Soa',
    route: '_id'
  },
  {
    id: 1,
    property: 'image.path',
    type: 'img',
    style: 'clientBalance',
    defaultImg: avatarUserDefault,
    nameRoute: 'Soa',
    route: '_id'
  },
  {
    id: 2,
    title: 'FIRST NAME',
    property: 'firstName',
    nameRoute: 'Soa',
    route: '_id',
    sort: true,
    hover: true
  },
  {
    id: 3,
    title: 'LAST NAME',
    property: 'lastName',
    nameRoute: 'Soa',
    route: '_id',
    sort: true,
    hover: true
  },
  {
    id: 4,
    title: 'NICKNAME',
    property: 'nickName',
    nameRoute: 'Soa',
    route: '_id',
    sort: true,
    hover: true
  },
  {
    id: 5,
    title: 'BALANCE, AED',
    property: 'accountBalance',
    nameRoute: 'Soa',
    route: '_id'
  },
  {
    id: 6,
    title: 'STATUS',
    property: 'totalReceived',
    dependence: 'totalInvoicedAed',
    statusDependence: true,
    nameRoute: 'Soa',
    route: '_id'
  },
  {
    id: 7,
    title: 'OVER- AND UNDERPAYMENTS, AED',
    property: 'totalReceived',
    dependence: 'totalInvoicedAed',
    statusBackground: true,
    nameRoute: 'Soa',
    route: '_id'
  }
]

export {balanceClientsTable, balanceClientsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/balanceClientsTable.js